import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    Container,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from '@mui/material';
import axios from 'axios';
import CloseIcon from '@mui/icons-material/Close';
import { toast } from 'react-toastify';

export default function CustomerDialog({ dialogOpen, setDialogOpen, petUpdateID, setPetUpdateID }) {
    const [petType, setpetType] = useState([]);
    const [newPetType, setnewPetType] = useState('');
    const [OwnerName, setOwnerName] = useState('');
    const [OwnerPhone, setOwnerPhone] = useState('');
    const [PetName, setPetName] = useState('');
    const [PetTypeDB, setPetTypeDB] = useState('');
    const [Breed, setBreed] = useState('');
    const [DOB, setDOB] = useState('');
    const [Age, setAge] = useState('');
    const [Gender, setGender] = useState('');
    const [Allergies, setAllergies] = useState('');
    const [Description, setDescription] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isUpdate, setIsUpdate] = useState(false);
    const [updatePetType, setUpdatePetType] = useState('');

    // Fetch all pets from the backend when the component mounts
    useEffect(() => {
        GetAllPets();
    }, []);

    useEffect(() => {
        if (petUpdateID){

            if (petUpdateID != 0 ) {
                GetPetDetailByID();
            }
        }
    }, [petUpdateID])

    const handlePetType = (event) => {
        setpetType(event.target.value);
    };

    const GetPetDetailByID = () => {
        axios.get(`https://serverfourpaws.ccsoftwares.com/Pet/getPetDetailByID/${petUpdateID}`).then((res) => {
            console.log("res:> ", res)
            if (res.status == 200) {
                setOwnerName(res.data[0].OwnerName);
                setOwnerPhone(res.data[0].OwnerPhone);
                setPetName(res.data[0].AnimalName);
                setUpdatePetType(res.data[0].AnimalType);
                setDOB(res.data[0].DOB);
                setBreed(res.data[0].Breed);
                setAge(res.data[0].Age);
                setGender(res.data[0].Gender);
                setAllergies(res.data[0].Allergies);
                setDescription(res.data[0].Description);
                setIsUpdate(true);
            }
        })
    }

    const GetAllPets = () => {
        axios.get('https://serverfourpaws.ccsoftwares.com/Pet/getAllPets/')
            .then((res) => {
                if (Array.isArray(res.data)) {
                    setpetType(res.data);
                } else {
                    setpetType([]);
                }
            })
            .catch(() => {
                setpetType([]);
            });
    };

    const setPetTypeFunc = async (e) => {
        e.preventDefault();
        try {
            await axios.post('https://serverfourpaws.ccsoftwares.com/Pet/createPet', { newPetType });
            setnewPetType('');
            GetAllPets();
        } catch (err) {
            console.error('Error creating new pet type:', err);
        }
    };

    const handleClose = () => {
        setDialogOpen(false);
        setPetUpdateID(0);
        setIsUpdate(false);
        setOwnerName('');
        setOwnerPhone('');
        setPetName('');
        setUpdatePetType('');
        setDOB('');
        setBreed('');
        setAge('');
        setGender('');
        setAllergies('');
        setDescription('');
    };

    const calculateAge = (dob) => {
        const today = new Date();
        const birthDate = new Date(dob);
    
        let years = today.getFullYear() - birthDate.getFullYear();
        let months = today.getMonth() - birthDate.getMonth();
        let days = today.getDate() - birthDate.getDate();
    
        // Adjust months and years if the current day is before the birth day
        if (days < 0) {
            months--;
        }
    
        // Adjust years and months if the current month is before the birth month
        if (months < 0) {
            years--;
            months += 12;
        }
    
        // Calculate the fractional part of the age based on months
        const fractionalAge = months / 12;
    
        // Combine years and fractional months
        const age = years + fractionalAge;
    
        // Round to one decimal place
        return parseFloat(age.toFixed(1));
    };

    useEffect(() => {
        if (DOB) {
            setAge(calculateAge(DOB));
        }
    }, [DOB]);

    const SubmitPetData = async (e) => {
        if (isUpdate) {
            const updateMoodel = {
                OwnerName: OwnerName,
                OwnerPhone: OwnerPhone,
                PetName: PetName,
                Breed: Breed,
                DOB: DOB,
                Age: Age,
                Gender: Gender,
                Allergies: Allergies,
                Description: Description,
                petUpdateID: petUpdateID
            }

            axios.put("https://serverfourpaws.ccsoftwares.com/Pet/UpdatePetDetails", updateMoodel).then((res) => {
                if (res.status == 200) {
                    handleClose();
                    toast.success("Pet Updated successfully!")
                }
            })
        } else {
            e.preventDefault();
            try {
                const response = await axios.post('https://serverfourpaws.ccsoftwares.com/Pet/AddNewPet', {
                    PetTypeDB,
                    OwnerName,
                    OwnerPhone,
                    PetName,
                    Breed,
                    DOB,
                    Age,
                    Gender,
                    Allergies,
                    Description,
                    shop: JSON.parse(localStorage.getItem("paws"))?.shop
                });

                setSuccess('Pet added successfully!');
                setError('');
                ClearData();
                setDialogOpen(false);
            } catch (err) {
                setSuccess('');
                setError('Error adding pet. Please try again.');
            }
        }
    };

    function ClearData() {
        setOwnerName('');
        setOwnerPhone('');
        setPetTypeDB('');
        setPetName('');
        setBreed('');
        setDOB('');
        setAge('');
        setGender('');
        setAllergies('');
        setDescription('');
    }

    return (
        <Dialog open={dialogOpen} fullWidth={true} maxWidth='md'>
            <DialogTitle>{isUpdate ? 'Update Pet Details' : 'Add New Pet'}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon sx={{ color: 'black' }} />
            </IconButton>
            <DialogContent dividers>
                <Container maxWidth={false}>
                    <Box mt={0}>
                        <Grid container spacing={2}>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    label="Owner Name"
                                    value={OwnerName}
                                    onChange={(e) => setOwnerName(e.target.value)}
                                    variant="outlined"
                                    size="medium"
                                    required
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    label="Owner Phone No"
                                    value={OwnerPhone}
                                    inputProps={{ maxLength: 10 }}
                                    onChange={(e) => setOwnerPhone(e.target.value)}
                                    variant="outlined"
                                    size="medium"
                                    required
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    label="Pet Name"
                                    value={PetName}
                                    onChange={(e) => setPetName(e.target.value)}
                                    variant="outlined"
                                    size="medium"
                                    required
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                {isUpdate ?
                                    <TextField
                                        fullWidth
                                        label="Pet Type"
                                        value={updatePetType}
                                        variant="outlined"
                                        size="medium"
                                        inputProps={{
                                            readOnly: isUpdate
                                        }}
                                    /> :
                                    <FormControl fullWidth required>
                                        <InputLabel id="petType-label">Pet Type</InputLabel>
                                        <Select
                                            id="petType"
                                            value={PetTypeDB}
                                            label="Pet Type"
                                            size="medium"
                                            onChange={(e) => setPetTypeDB(e.target.value)}
                                        >
                                            {petType.map((type, index) => (
                                                <MenuItem key={index} value={type.AnimalType}>
                                                    {type.AnimalType}
                                                </MenuItem>
                                            ))}
                                            <MenuItem value="Other">Other</MenuItem>
                                        </Select>
                                    </FormControl>
                                }
                            </Grid>
                            {PetTypeDB === "Other" && (
                                <>
                                    <Grid item md={6} xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Add New Pet Type"
                                            value={newPetType}
                                            onChange={(e) => setnewPetType(e.target.value)}
                                            variant="outlined"
                                            size="medium"
                                        />
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <Button variant="contained" onClick={setPetTypeFunc}>
                                            Submit Pet
                                        </Button>
                                    </Grid>
                                </>
                            )}
                            <Grid item md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    label="Breed"
                                    value={Breed}
                                    onChange={(e) => setBreed(e.target.value)}
                                    variant="outlined"
                                    size="medium"
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    label="DOB"
                                    type="date"
                                    value={DOB}
                                    onChange={(e) => setDOB(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    size="medium"
                                    required
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    label="Age"
                                    value={Age}
                                    variant="outlined"
                                    size="medium"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item md={6} xs={12}>
                                <FormControl fullWidth required>
                                    <InputLabel id="gender-label">Gender</InputLabel>
                                    <Select
                                        id="gender"
                                        value={Gender}
                                        label="Gender"
                                        onChange={(e) => setGender(e.target.value)}
                                        inputProps={{
                                            readOnly: isUpdate
                                        }}
                                    >
                                        <MenuItem value="Male">Male</MenuItem>
                                        <MenuItem value="Female">Female</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <TextField
                                    fullWidth
                                    label="Allergies "
                                    value={Allergies}
                                    onChange={(e) => setAllergies(e.target.value)}
                                    variant="outlined"
                                    size="medium"
                                />
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <TextField
                                    fullWidth
                                    label="Description "
                                    value={Description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    variant="outlined"
                                    size="medium"
                                    multiline
                                    rows={3}
                                />
                            </Grid>
                            <Grid item md={12} xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                {isUpdate ? null :
                                    <Button variant="contained" size="large" onClick={ClearData} sx={{ width: '30%' }}>
                                        Clear
                                    </Button>
                                }
                                &nbsp;&nbsp;&nbsp;
                                <Button variant="contained" size="large" onClick={SubmitPetData} sx={{ width: '30%' }}>
                                    {isUpdate ? 'Update' : 'Submit'}
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </DialogContent>
        </Dialog>
    );
}


